import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 1rem;
`;

export const Collapse = styled.div`
  margin-top: 0.75rem;
`;

export const PreviewBox = styled.pre`
  white-space: pre-wrap;
  background: #f5f5f5;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 0.8125rem;
  max-height: 200px;
  overflow: auto;
  margin-top: 0.5rem;
`;
